import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
export var SET_CART = 'SET_CART';
export var SET_CART_QTY = 'SET_CART_QTY';
export var SET_CART_SUCCESS = 'SET_CART_SUCCESS';
export var SET_CART_SUCCESS_SERVER = 'SET_CART_SUCCESS_SERVER';
export var SET_CART_STATE = 'SET_CART_STATE';